import { render, staticRenderFns } from "./PartCategoryAdd.vue?vue&type=template&id=b55d5f52"
import script from "./PartCategoryAdd.vue?vue&type=script&lang=ts"
export * from "./PartCategoryAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports